import iconUpload from "../../images/icon-upload.svg";
import React from "react";

export default function CmpnyTab({ user, cmpnyListDatas, setCompanyName, cmpnySeq, setCmpnySeq, fileRef, fileName, setFileName, fileHandler, setCompanyPopup, setIsSctrGbPopOpen, setSelectedSctrGb, setTab }: any) {
  const selectHandler = (cmpnyNm: string, cmpnySeq: number, sctrGb: string) => {
    setCompanyName(cmpnyNm);
    setCmpnySeq(cmpnySeq);
    setSelectedSctrGb(sctrGb);
  }
  const fn_skip = () => {
    setCompanyName('무소속');
    setCmpnySeq(null);
    setIsSctrGbPopOpen(true);
    setTab('exbtPlc');
    setCompanyPopup(false);
  }
  return (<>
    <div className='mt-23 md:mt-57'>
      <div className='flex justify-evenly'>
        <div onClick={() => setCompanyPopup(true)}
             className='flex flex-col justify-center items-center w-120 py-13 md:w-[250px] md:py-20 text-white text-19 leading-18 md:text-60 md:leading-45 bg-gradient-to-r from-gdFrom to-gdTo rounded-[4px] md:rounded-[10px]'>
          <p>업체명</p>
          <p className='mt-6'>검색</p>
        </div>
        <div onClick={fn_skip}
             className='flex flex-col justify-center items-center w-120 py-13 md:w-[250px] md:py-20 text-19 leading-18 md:text-60 md:leading-45 outline-none text-[#00A0FD] border-[#00A0FD] border-2 rounded-[5px] md:rounded-[12px]'>
          <p>업체명</p>
          <p className='mt-6'>모름</p>
        </div>
      </div>
      <div className='flex flex-col justify-center items-center mt-20 text-15 leading-18 md:mt-82 md:text-37 md:leading-45'>
        { cmpnyListDatas.length > 0 && <p className='w-full ml-8 md:ml-20'>기존 소속 업체</p> }
        {cmpnyListDatas.length === 0
            ? <></>
            : cmpnyListDatas.map((c: any, idx: number) => {
              return (
                  <div key={idx} onClick={() => selectHandler(c.cmpnyNm, c.cmpnySeq, c.sctrGb)} className={c.cmpnySeq === cmpnySeq
                      ? 'mt-17 border border-point w-[90%] h-52 rounded-[5px] md:rounded-[12px] text-15 leading-18 md:text-37 md:leading-45 text-point flex items-center pl-13 md:pl-32'
                      : 'mt-17 border border-[#D9D9D9] w-[90%] h-52 rounded-[5px] md:rounded-[12px] text-15 leading-18 md:text-37 md:leading-45 text-[#9C9C9B] font-preLight flex items-center pl-13 md:pl-32'}>{c.cmpnyNm} </div>)
            })}

        {/*<div onClick={selectHandler}*/}
        {/*     className='mt-15 flex flex-col justify-center items-center w-[80%] py-15 md:w-[250px] md:py-30 text-19 leading-18 md:text-60 md:leading-45 outline-none text-[#E05185] border-[#E05185] border-2 rounded-[5px] md:rounded-[12px]'>*/}
        {/*  <p>업체명</p>*/}
        {/*</div>*/}
      </div>

    </div>

    {/*<p className='ml-8 mt-30 md:ml-[20px] md:mt-[75px] md:text-[30px]'>건설기초안전 이수증 첨부 {user.cnstrAtchFileId ? ' (완료)' : null}</p>*/}
    {/*{user.cnstrAtchFileId ?*/}
    {/*  <img src={'admin/api/cmmn/fileDownload?atchFileId=' + user.cnstrAtchFileId + '&fileSn=0'} onClick={fileHandler} alt='' className='w-[235px] h-129 md:w-[587px] md:h-[322px] border boder-[#D9D9D9] rounded-[5px] md:rounded-[12px]' />*/}
    {/*  : !fileName*/}
    {/*    ? <button onClick={fileHandler} className='w-148 h-49 mt-18 ml-8 md:w-[370px] md:h-[122px] md:mt-[45px] md:ml-[20px] flex justify-center items-center outline-none border border-dashed border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-[#C9C9C9] font-preLight'>*/}
    {/*      <img className='w-15 mr-12 md:w-37 md:mr-30' src={iconUpload} alt='upload' />*/}
    {/*      <p className='md:text-[30px]'>파일 올리기</p>*/}
    {/*    </button>*/}
    {/*    : <button onClick={fileHandler} className='w-148 h-49 mt-18 ml-8 md:w-[370px] md:h-[122px] md:mt-[45px] md:ml-[20px] flex justify-center items-center outline-none border border-point rounded-[5px] md:rounded-[12px] text-14 md:text-35 text-point font-preLight truncate'>{fileName}</button>}*/}
    {/*<input hidden onChange={(e) => setFileName(e.target.value.substring(12))} type='file' ref={fileRef} />*/}
  </>);
}